/**
 * @typedef {import('./TicketSelector').PricetypeQuantities} PricetypeQuantities
 */

class PreselectedPricetypeQuantities {
  /**
   * @param {PricetypeQuantities} pricetypeQuantities
   */
  constructor(pricetypeQuantities) {
    this.pricetypeQuantities = pricetypeQuantities;
  }

  getAllPricetypeQuantities() {
    return this.pricetypeQuantities;
  }

  getTotalQuantitySelected() {
    return this.pricetypeQuantities
      .reduce((sum, { quantity }) => sum + quantity, 0);
  }

  getIsSelectionValid() {
    return true;
  }
}

export default PreselectedPricetypeQuantities;



// WEBPACK FOOTER //
// ./src/events/detail/PreselectedPricetypeQuantities.js